import { createService } from './config/axios';
import {
  TGetCourseListResponse,
  TGetCourseInfoListResponse,
  TGetStudClassListResponse,
  TGetChartRoundResponse,
  TGetStudentUserListResponse,
} from 'types/apis/common';

export const getCourseList = async () =>
  await createService<TGetCourseListResponse>({
    url: '/drop-down/admin-professor/course',
    options: {
      method: 'get',
    },
  });

export const getCourseInfoList = async () =>
  await createService<TGetCourseInfoListResponse>({
    url: '/drop-down/all-user/course-info',
    options: {
      method: 'get',
    },
  });

export const getStudentCourseListByProfessor = async (userId: number) =>
  await createService<TGetCourseInfoListResponse>({
    url: `/professor-student/student/taken-course/by-professor/${userId}`,
    options: {
      method: 'get',
    },
  });

export const getStudClassList = async (courseId: string) =>
  await createService<TGetStudClassListResponse>({
    url: `/drop-down/all-user/stud-class-info/${courseId}`,
    options: {
      method: 'get',
    },
  });

export const getChartRoundList = async (courseInfoId: string) =>
  await createService<TGetChartRoundResponse>({
    url: `/drop-down/all-user/registered-chart-info/${courseInfoId}`,
    options: {
      method: 'get',
    },
  });

export const getStudentUserList = async (
  courseInfoId: string,
  chartRound: string
) =>
  await createService<TGetStudentUserListResponse>({
    url: `/drop-down/professor/statistics/student-list/${courseInfoId}/${chartRound}`,
    options: {
      method: 'get',
    },
  });
